
import CustomEvent from './CustomEvent'

const CustomEventWrapper = (props) => {
    return <CustomEvent {...props} 
    setHasCopiedShift={props.setHasCopiedShift} />
  };
  
  export default CustomEventWrapper;
  